import { createIframeDiagnosticsHost } from '@patsnap/synapse_common_utils'
import type { DiagnosticEventSink, IframeDiagnosticsHost } from '@patsnap/synapse_common_utils'

let diagnosticEventSink: DiagnosticEventSink | undefined
let iframeDiagnosticsHost: IframeDiagnosticsHost | undefined
let diagnosticsEnabled = false

export function configureIframeDiagnosticSink(sink?: DiagnosticEventSink): void {
  diagnosticEventSink = sink
  if (!sink) {
    iframeDiagnosticsHost?.destroy()
    iframeDiagnosticsHost = undefined
  }
}

export function setIframeDiagnosticsEnabled(enabled: boolean): void {
  diagnosticsEnabled = enabled
  iframeDiagnosticsHost?.setEnabled(enabled)
}

export function installIframeDiagnosticAdapter(): void {
  if (iframeDiagnosticsHost || !diagnosticEventSink || typeof window === 'undefined' || typeof document === 'undefined') return

  try {
    iframeDiagnosticsHost = createIframeDiagnosticsHost<HTMLIFrameElement>({
      onEvent: (event) => diagnosticEventSink?.(event),
      resolveSourceIframe: (source) => {
        return Array.from(document.querySelectorAll('iframe')).find((iframe) => iframe.contentWindow === source)
      },
      resolveTargetOrigin: getIframeOrigin,
      isAllowedOrigin: (origin, iframe) => origin === getIframeOrigin(iframe),
    })
    iframeDiagnosticsHost.setEnabled(diagnosticsEnabled)
  } catch {
    iframeDiagnosticsHost = undefined
    // Diagnostics must not prevent application startup.
  }
}

function getIframeOrigin(iframe: HTMLIFrameElement): string | undefined {
  const iframeSrc = iframe.getAttribute('src')?.trim()
  if (!iframeSrc) return undefined

  try {
    const url = new URL(iframeSrc, window.location.href)
    if ((url.protocol !== 'http:' && url.protocol !== 'https:') || url.origin === 'null') return undefined
    return url.origin
  } catch {
    return undefined
  }
}
